import { useEffect } from 'react';

/*
  冷启动时滚动到 URL 锚点。

  浏览器原生的锚点跳转发生在文档解析阶段，而 SPA 那时候 React 还没把内容渲染出来，
  于是像 /term/privacyPolicy#account-deletion 这种深链打开后只会停在页面顶部。
  该链接是对外登记的「账号删除说明」地址，必须能落到对应段落。

  渲染完成后（useEffect）再补一次滚动即可。只在挂载时执行：挂载之后 DOM 已存在，
  页内点击锚点由浏览器原生处理，无需重复接管。
*/
const useHashScroll = () => {
  useEffect(() => {
    const raw = window.location.hash.replace(/^#/, '');
    if (!raw) {
      return undefined;
    }

    let id = raw;
    try {
      id = decodeURIComponent(raw);
    } catch (e) {
      // hash 不是合法的百分号编码，按原样查找
    }

    // 延后一拍，等首屏布局稳定后再滚，避免滚到随后发生位移的位置
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView();
      }
    }, 0);

    return () => clearTimeout(timer);
  }, []);
};

export default useHashScroll;
